var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("RaonFit")]),_c('p',[_vm._v("가입하신 아이디/비밀번호를 입력하세요.")]),_c('LoginForm',{attrs:{"id":_vm.id,"password":_vm.password}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }